import { Injectable } from '@angular/core';
import * as english from "../languages/language.en";
import * as swedish from "../languages/language.se";
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: "root"
})
export class LanguageService {

    availableLanguages = [
        { lang: "Svenska", code: "se" },
        { lang: "English", code: "en" },

    ];

    currentLanguage: string;
    currentLanguageSubject: BehaviorSubject<string>;

    constructor() {
        const storedLang = localStorage.getItem('language');
        this.currentLanguage = storedLang ? storedLang : 'se';
        this.currentLanguageSubject = new BehaviorSubject(this.currentLanguage);
    }

    getAvailableLanguages() {
        return this.availableLanguages;
    }

    setLanguage(languageCode: string) {
        this.currentLanguage = languageCode;
        localStorage.setItem('language', languageCode);
        this.currentLanguageSubject.next(this.currentLanguage);
    }

    getString(translationProperty: string, languageCode?: string, parameters?: string[]): string {
        languageCode = languageCode || this.currentLanguage;
        switch (languageCode) {
            case "se": {
                if (parameters) {
                    return swedish.lang.get(translationProperty, parameters);
                } else if (Object.prototype.hasOwnProperty.call(swedish.lang, translationProperty) && typeof swedish.lang[translationProperty as keyof typeof swedish.lang] === 'string') {
                    return swedish.lang[translationProperty as keyof typeof swedish.lang] as string;
                } else {
                    return translationProperty;
                }
            }
            case "en": {
                if (parameters) {
                    return english.lang.get(translationProperty, parameters);
                } else if (Object.prototype.hasOwnProperty.call(english.lang, translationProperty) && typeof english.lang[translationProperty as keyof typeof english.lang] === 'string') {
                    return english.lang[translationProperty as keyof typeof english.lang] as string;
                } else {
                    return translationProperty;
                }
            }
            default: {
                return translationProperty;
            }
        }
    }
}
